<template>
    <div class="navbar-app">
        <nav :class="lightMood === true ? 'navbar navbar-expand-lg navbar-light navbarBackgroundCopy' : 'navbar navbar-expand-lg navbar-light navbarBackground'" style="color: #fff !important">
            <div class="container-fluid">
                <img v-if="lightMood === true" src="../../assets/images/MainIconLight.svg" alt="">
                <img v-else src="../../assets/images/logoDesign.png" alt="">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li class="nav-item">

                        </li>
                        <li class="nav-item">

                        </li>
                    </ul>
                    <div class="d-flex">
                        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link" href="#" @click="changAppMood"
                                :title="lightMood ? 'Switch to dark mood' : 'Switch to light mood'"
                                >
                                    <font-awesome-icon :icon="['fas', lightMood ?  'circle-half-stroke' : 'moon']" size="lg"/>
                                </a>
                            </li>

                            <li class="nav-item">
                                <router-link :to="'/profile'">
                                    <a class="nav-link" href="#">
                                        <font-awesome-icon :icon="['fas', 'user']" size="lg"/>
                                    </a>
                                </router-link>
                            </li>
<!--                            <li class="nav-item">-->
<!--                                <a class="nav-link" href="#">-->
<!--                                    <font-awesome-icon :icon="['fas', 'bell']" size="lg"/>-->
<!--                                </a>-->
<!--                            </li>-->
                            <li class="nav-item">
                                <a class="nav-link" href="#" @click="logout">
                                    <font-awesome-icon :icon="['fas', 'sign-out']" size="lg"/>
                                </a>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    </div>

    <ConfirmationModal v-if="this.isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import {computed} from "vue";
    import ConfirmationModal from "./ConfirmationModal";

    export default {
        name:'navbar-app',
        data(){
            return {
                error:false,
                user:{},
                isFull: false,
                 confirmMessage: '',
                confirmModal: false,
                lightMood:null,
                // confirmModal: computed(() => this.$store.state.settings.confirmModal),
                // confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },
        mounted(){
            this.user = this.$store.state.auth.user;
            this.lightMood = this.$store.state.settings.isLightMood;
        },
        computed:{
          lightMood(){
              return this.$store.state.settings.isLightMood;
            }
        },
        components:{
            ConfirmationModal
        },
        methods: {
            async logout(){
                try{
                    this.confirmModal = true;
                    this.confirmMessage = 'Are you sure you want to logout?'

                }catch (e) {
                    this.error = e;
                }
            },

            async confirmModalHandler (event) {
                this.isFull = false;
                this.confirmModal = false;
                if(event){
                    await this.$store.dispatch('logout');
                    await this.$router.push({name: 'login-page'});
                }
            },

            async changAppMood(e){
                if(!this.$store.state.settings.isLightMood){
                    localStorage.setItem('lightmood' , true);
                }else{
                    localStorage.setItem('lightmood' , false);
                }
                this.$store.dispatch('setIsLightMood', !this.$store.state.settings.isLightMood);
            }
        }
    }
</script>

<style>
    .navbar-light .navbar-nav .nav-link{
        color: var(--link-icons-navbar) !important;
    }
    .navbar-light .navbar-brand{
        color: #fff !important;
    }
    .navbarBackground{
        background-image: url("../../assets/images/divBackgroundColor.jpg");
        padding: 20px !important;
        display: flex;
        justify-content: space-between;
        width: 100vw;
        background-repeat: no-repeat;
        background-position: 72%;
        background-size: 2000px;
        border-bottom: 1px solid var(--table-border);
        box-shadow: 0px 0px 15px -10px #ccc;
    }
    .navbarBackgroundCopy{
        background-image: none;
        padding: 20px !important;
        display: flex;
        justify-content: space-between;
        width: 100vw;
        background-repeat: no-repeat;
        background-position: 72%;
        background-size: 2000px;
        border-bottom: 1px solid var(--table-border);
        box-shadow: 0px 0px 15px -10px #ccc;
    }
</style>